import { useState } from "react";
import { IonSegment, IonSegmentButton } from "@ionic/react";
import { useAuth } from "pages";
import { BillingPage } from "pages/more";

import { translate } from "~utils";

import { Budgets } from "./components/Budgets";

export function BillingPortalPage() {
  const billingPortalTabs = [
    translate("BILLING_PORTAL_TAB_BUDGETS"),
    translate("BILLING_PORTAL_TAB_INVOICES"),
  ];

  const [tab, setTab] = useState(billingPortalTabs[0]);

  const { userInfo } = useAuth();
  const showTabs = userInfo.isBillingAdmin || userInfo.isSuperAdmin;

  return (
    <div css={{ maxWidth: 900, padding: "0 16px", margin: "0 auto" }}>
      {showTabs && (
        <IonSegment
          css={{ width: "100%", display: "flex" }}
          value={tab}
          onIonChange={(e) => setTab(e.target.value as string)}
        >
          <IonSegmentButton css={{ flex: "1 1 auto" }} value={billingPortalTabs[0]}>
            {billingPortalTabs[0]}
          </IonSegmentButton>
          <IonSegmentButton css={{ flex: "1 1 auto" }} value={billingPortalTabs[1]}>
            {billingPortalTabs[1]}
          </IonSegmentButton>
        </IonSegment>
      )}
      {/* TODO:  Move Billing Portal Page into `src/pages/components` */}
      {tab === billingPortalTabs[0] && <Budgets />}
      {tab === billingPortalTabs[1] && <BillingPage />}
    </div>
  );
}
